import React from "react";
import "./TeacherResearchProjects.css"

const TeacherResearchProjects = ({teacher, type}) => {
    if (!["research", "project"].includes(type)){
        return <h4>Invalid type</h4>
    }

    const data = teacher.research_projects.filter(item=>item.type === type);
    data?.sort((a, b) => b.year - a.year);
    const current_data = data.filter(item => item.status === "current")
    const old_data = data.filter(item => item.status === "previous")

    const truncateText = (text, wordLimit) => {
        const words = text.split(" ");
        return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : text;
    };

    return (
        <div className="research-project-list">           
            {current_data.map(item => (
                    <div key={item.id} className="teacher-data-item research-project-card">
                        <div className="research-project-card-inner">
                            <p>
                                <span className="ongoing">ON-GOING</span>
                                <span className={"item-type-" + type}>{type}</span>
                            </p>

                            <h3>{item.title}</h3>
                            <p>{truncateText(item.description, 30)}</p>
                            {item.collaborators && item.collaborators.length > 0 && <p><strong>Collaborators:</strong> {item.collaborators.join(", ")}</p>}
                            <p></p>
                            <p style={{marginTop: 'auto'}}><a className="btn-view-details" href={item.url}>🡒View details</a></p>
                        </div>
                        {item.featured_image && 
                            <div className="research-project-featured-img" 
                            style={{backgroundImage: "url("+ item.featured_image + ")"}}>
                            </div>
                        }
                            
                    </div>
            ))}
            
            {old_data.map(item => (
                    <div key={item.id} className="teacher-data-item research-project-card">
                        <div className="research-project-card-inner">
                            <p>                                
                                <span className={"item-type-" + type}>{type}</span>
                            </p>

                            <h3>{item.title}</h3>
                            <p>{truncateText(item.description, 30)}</p>
                            {item.collaborators && item.collaborators.length > 0 && <p><strong>Collaborators:</strong> {item.collaborators.join(", ")}</p>}
                            <p></p>
                            <p style={{marginTop: 'auto'}}><a className="btn-view-details" href={item.url}>🡒View details</a></p>
                        </div>
                        {item.featured_image && 
                            <div className="research-project-featured-img" 
                            style={{backgroundImage: "url("+ item.featured_image + ")"}}>
                            </div>
                        }
                            
                    </div>
            ))}
        </div>
    );
};

export default TeacherResearchProjects;
